import { SubmitButton } from '../../../../Form';
import { useFormContext } from '../AddSessionForm.types';


export const AddSessionFormSubmitButton: typeof SubmitButton = (props) => {
  const formContext = useFormContext();

  return (
    <SubmitButton disabled={formContext.status?.submissionBlocked} {...props} />
  );
};
